import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getProductSku: { args: ["payload"], meta: { async: true } },
    getAllProductSkus: { args: ["payload"], meta: { async: true } },
    createProductSku: { args: ["payload"], meta: { async: true } },
    editProductSku: { args: ["payload"], meta: { async: true } },
    deleteProductSku: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/ProductSkus/",
  },
);
export const ActionTypes = Types;
export default Creators;
